import React from 'react';

import { ButtonBase, makeStyles, Tooltip } from '@material-ui/core';
import { FilterList } from '@material-ui/icons';

const useStyles = makeStyles(({ palette, typography }) => ({
  root: {
    borderRadius: 8,
    backgroundColor: palette.background.tertiary,
    border: `1px solid ${palette.divider}`,
    height: typography.pxToRem(40),
    width: typography.pxToRem(40),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: palette.action.hover,
    },
  },
}));

interface FilterButtonProps {
  onClick: () => void;
}

function FilterButton({ onClick }: FilterButtonProps) {
  const classes = useStyles();

  return (
    <Tooltip title="Filtros">
      <ButtonBase className={classes.root} onClick={onClick}>
        <FilterList color="action" />
      </ButtonBase>
    </Tooltip>
  );
}

export default FilterButton;
